export enum HearingStatus {
  Agendada = "agendada",
  Confirmada = "confirmada",
  Realizada = "realizada",
  Cancelada = "cancelada",
  Finalizada = "finalizada",
}

export enum HearingPaymentStatus {
  Agendado = "agendado",
  Pago = "pago",
  Cancelado = "cancelado",
  ErroAoPagar = "erro",
  Aprovado = "aprovado",
}

export enum HearingAgentStatus {
  Convidado = 1,
  Aceito = 2,
}

export enum PaymentStatus {
  EM_ABERTO = "Agendado",
  EM_PROCESSAMENTO = "Em processamento",
  REALIZADO = "Realizado",
  NAO_REALIZADO = "Erro ao realizar pagamento",
  RETENTATIVA = "Em retentativa de processamento",
  CANCELADO = "Cancelado",
}
